import AbstractModalView from './AbstractModalView-redux';

export default AbstractModalView;
